import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'
import { CSSProperties, SyntheticEvent } from 'react'

const ContentfulReplacementRegex = new RegExp('//images\\.ctfassets\\.net/afruo3gr1g6h/', 'g')

export const IMAGE_DOMAIN_NAME = 'images.quince.com'

export function transformImageSrc(url: string) {
  try {
    return url.replace(ContentfulReplacementRegex, `//${IMAGE_DOMAIN_NAME}/`)
  } catch (error) {
    // @i18n-ignore
    const e = new Error('Failed to transform Image at transformImageSrc')
    // @i18n-ignore
    e.name = 'Failed to transform Image'

    captureException(e, {
      module: MODULES.UNKNOWN,
      feature: FEATURES.IMAGE_TRANSFORMATION,
      extraInfo: {
        originalError: JSON.stringify(error),
        url: url,
      },
    })
  }
  return url
}

export const getCommonImageVideoCSS = (): Partial<CSSProperties> => {
  // @i18n-ignore-start
  return {
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center center',
    opacity: 1,
    transition: 'none 0s ease 0s',
  }
  // @i18n-ignore-end
}

export const addImageRequestSource = (src: string): string => {
  if (typeof src !== 'string' || !src.trim()) {
    return src
  }

  const isBase64Source = src.trim().startsWith('data:image')

  if (isBase64Source) {
    return src.trim()
  }

  return src.trim() + (src.includes('?') ? '&' : '?') + 'reqOrigin=website-ssr'
}

export const getErrorFromEvent = (event: SyntheticEvent<HTMLImageElement>) => {
  try {
    const nativeEvent = event.nativeEvent

    // @i18n-ignore
    const errorMessage = `Image failed to load: ${event.currentTarget.src}`

    const error = new Error(errorMessage)
    // @i18n-ignore
    ;(error as any).name = 'ImageLoadError'
    ;(error as any).eventType = nativeEvent.type
    ;(error as any).imgSrc = event.currentTarget.src

    return error
  } catch (err) {
    // @i18n-ignore
    return new Error('Unhandled error in image')
  }
}
